// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://fmmcpkpxsuxsqcxfwnch.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZtbWNwa3B4c3V4c3FjeGZ3bmNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI0MTMxNDYsImV4cCI6MjA2Nzk4OTE0Nn0.6l-lYAPojJbB2u1fJm8YRXmxmCOeSRNVg64FJxG6LKk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});